import React from 'react';
import DroppableArea from '../../components/DraggableItem/DroppableArea/DroppableArea';

function TasksPage() {
  return (
    <div>
      <DroppableArea />
    </div>
  );
}

export default TasksPage;
